module.exports = __webpack_public_path__ + "assets/img/index1.7466cc6f.jpg";